// import firebase from 'firebase';
import firebase from '@/firebase/firestore';
import store from "@/store";
import router from '@/router.js';

export default {
  init() {
    // firebase.initializeApp(config);
    // firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION);
  },
  signup(email, password) {
    firebase.auth().createUserWithEmailAndPassword(email, password).then(
      (user) => {
        alert('Your account has been created !');
        this.login(this.email, this.password);
        console.log(user);
      },
    );
  },
  loginGoogle() {
    const provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithPopup(provider);
  },
  login(email, password) {
    firebase.auth().signInWithEmailAndPassword(email, password).then(
      (user) => {
        this.onAuth();
        this.checkForProfile();
        this.success();
        console.log(user);
      },
    )
    .catch((err) => {
      alert('Opps. ' + err.message);
    });
  },
  logout() {
    firebase.auth().signOut().then(
      (user) => {
        alert('Disconnected!');
        router.replace('/');
        console.log(user);
      },
    )
  },
  onAuth() {
    let uid = '';
    firebase.auth().onAuthStateChanged((user) => {
      uid = firebase.auth().currentUser.uid;
      store.dispatch('fetchAccount',{user, uid})
      // store.commit('onAuthStateChanged', user);
      // store.commit('onUserStatusChanged', Boolean(user), !!user);
    });
  },
  success() {
    alert('Well done! You are connected!' + firebase.auth().currentUser.uid);
    router.push({ name: 'home', params: { userId: firebase.auth().currentUser.uid } });
  },
  checkForProfile() {
    const db = firebase.firestore().collection('user');
      db
      .doc(firebase.auth().currentUser.uid)
      .set({
        uid: firebase.auth().currentUser.uid,
        email: firebase.auth().currentUser.email,
      });
      console.log(firebase.auth().currentUser.uid);
  },
};
